import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputSearch } from '@/pcomponents/common/date_picker/custom_input';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";

function SearchArea(props: any) {
  let myProps = {
    listOpt: {
      "s_reserve_start_date": "",
      "s_reserve_end_date": "",
      "s_is_success": "",
    },
    list: (inData: any) => { },
    ...props
  };
  let listOpt = myProps.listOpt;
  let select_counsel_kind_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'counsel_todo', 'key': 'a_kind' });

  const goDateDayChange = (sort: "pre" | "next") => {
    //next,pre
    let selected_date = listOpt.s_reserve_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let change_date_obj = new Date(selected_date);
    if (sort == "pre") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', -1);
    } else if (sort == "next") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', +1);
    }

    let start_date = DateFunc.get_date_format(change_date_obj, "Y-m-01");
    let end_date = DateFunc.get_date_format(change_date_obj, "Y-m-t");
    myProps.list({
      now_page: "1",
      s_reserve_start_date: start_date,
      s_reserve_end_date: end_date,
    });
  };
  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    myProps.list({ now_page: 1, [key]: date_str });
  };

  return (
    <div>
      <div style={{ display: "inline-block", width: 90 }}>
        <DatePicker
          wrapperClassName="pl-1"
          selected={listOpt.s_reserve_start_date != "" ? new Date(listOpt.s_reserve_start_date) : null}
          onChange={(date: Date) => {
            onChangeDatePicker("s_reserve_start_date", date);
          }}
          locale={ko}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInputSearch />}
          renderCustomHeader={customHeaderFunc}
        />
      </div>
      ~
      <div style={{ display: "inline-block", width: 90 }}>
        <DatePicker
          wrapperClassName="pl-1"
          selected={listOpt.s_reserve_end_date != "" ? new Date(listOpt.s_reserve_end_date) : null}
          onChange={(date: Date) => {
            onChangeDatePicker("s_reserve_end_date", date);
          }}
          locale={ko}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInputSearch />}
          renderCustomHeader={customHeaderFunc}
        />
      </div>
      <button className="btn-s2 btn-dark ml-1" onClick={() => { goDateDayChange("pre"); }}>◀</button>
      <button className="btn-s2 btn-dark ml-1" onClick={() => { goDateDayChange("next"); }}>▶</button>
      <button className="btn-s2 btn-dark ml-1" onClick={() => {
        myProps.list({
          "s_reserve_start_date": DateFunc.get_date_format(new Date(), "Y-m-01"),
          "s_reserve_end_date": DateFunc.get_date_format(new Date(), "Y-m-t"),
        });
      }}>
        이번달
      </button>
      <select className="search-input ml-1" value={listOpt.s_is_success} name={"s_is_success"}
        onChange={(e: any) => { myProps.list({ "s_is_success": e.target.value, now_page: 1 }); }} >
        <option value="">상태</option>
        <option value="1">완료</option>
        <option value="empty">미완료</option>
      </select>

      <span className="ml-2" style={{display:"inline-block"}}>
        <SelectBoxBar
          valueTextArr={[
            { text: "전체", value: "" },
            ...select_counsel_kind_option_arr
          ]}
          value={listOpt.s_kind}
          name={"s_kind"}
          on_change={(inData: any) => {
            myProps.list({ s_kind: inData.value, now_page: 1 });
          }}
        ></SelectBoxBar>
      </span>
    </div>
  );
};
export default SearchArea;